import { gql } from '@apollo/client';

export const listChargersV2Shallow = gql`
  query listChargersV2Shallow($input: ListChargersV2Input) {
    listChargersV2(input: $input) {
      total
    }
  }
`;
